/*
 * ATLAS source tracker — remembers where a visitor came from (first + last visit)
 * so the COD form can write it into the order. First-party only, no external calls.
 */
(function () {
  'use strict';
  var KEY = 'atlas_src_v1';
  var MAX_AGE_DAYS = 60;
  var OWN = location.hostname.replace(/^www[.]/, '').toLowerCase();

  function params() {
    var out = {};
    try {
      new URLSearchParams(location.search).forEach(function (v, k) { out[k.toLowerCase()] = String(v).slice(0, 200); });
    } catch (e) {}
    return out;
  }
  function hostOf(url) {
    try { return new URL(url).hostname.replace(/^www[.]/, '').toLowerCase(); } catch (e) { return ''; }
  }
  function has(re, s) { return !!s && re.test(s); }

  var AI = [
    ['chatgpt', 'ChatGPT', /(^|[.])chatgpt[.]com$|(^|[.])chat[.]openai[.]com$|(^|[.])openai[.]com$/, /^(chatgpt([.]com)?|openai)$/],
    ['perplexity', 'Perplexity', /(^|[.])perplexity[.]ai$/, /^perplexity([.]ai)?$/],
    ['gemini', 'Gemini', /^(gemini|bard)[.]google[.]com$/, /^(gemini|bard)([.]google[.]com)?$/],
    ['copilot', 'Copilot', /^copilot[.]microsoft[.]com$|(^|[.])copilot[.]cloud[.]microsoft$|^edgeservices[.]bing[.]com$/, /^copilot([.]microsoft[.]com)?$/],
    ['claude', 'Claude', /(^|[.])claude[.]ai$/, /^claude([.]ai)?$/],
    ['deepseek', 'DeepSeek', /(^|[.])deepseek[.]com$/, /^deepseek([.]com)?$/],
    ['grok', 'Grok', /(^|[.])grok[.]com$/, /^grok([.]com)?$/],
    ['meta_ai', 'Meta AI', /(^|[.])meta[.]ai$/, /^meta[.]?ai$/],
    ['mistral', 'Mistral Le Chat', /^chat[.]mistral[.]ai$/, /^(mistral|lechat)$/]
  ];
  var SOCIAL = [
    ['facebook', 'Facebook', /(^|[.])facebook[.]com$|^fb[.]me$/],
    ['instagram', 'Instagram', /(^|[.])instagram[.]com$/],
    ['tiktok', 'TikTok', /(^|[.])tiktok[.]com$/],
    ['youtube', 'YouTube', /(^|[.])youtube[.]com$|^youtu[.]be$/],
    ['pinterest', 'Pinterest', /(^|[.])pinterest[.][a-z.]+$|^pin[.]it$/],
    ['snapchat', 'Snapchat', /(^|[.])snapchat[.]com$/],
    ['x', 'X (Twitter)', /^(t[.]co|x[.]com|twitter[.]com)$/],
    ['linkedin', 'LinkedIn', /(^|[.])linkedin[.]com$|^lnkd[.]in$/],
    ['whatsapp', 'WhatsApp', /^(wa[.]me|web[.]whatsapp[.]com|api[.]whatsapp[.]com|chat[.]whatsapp[.]com)$/],
    ['telegram', 'Telegram', /^(t[.]me|web[.]telegram[.]org)$/]
  ];
  var SEARCH = [
    ['google', 'Recherche Google', /(^|[.])google[.][a-z.]+$/],
    ['bing', 'Recherche Bing', /(^|[.])bing[.]com$/],
    ['duckduckgo', 'DuckDuckGo', /(^|[.])duckduckgo[.]com$/],
    ['yahoo', 'Recherche Yahoo', /(^|[.])yahoo[.][a-z.]+$/],
    ['yandex', 'Yandex', /(^|[.])yandex[.][a-z.]+$/],
    ['ecosia', 'Ecosia', /(^|[.])ecosia[.]org$/],
    ['brave', 'Brave Search', /^search[.]brave[.]com$/],
    ['qwant', 'Qwant', /(^|[.])qwant[.]com$/]
  ];
  var IN_APP = [
    ['facebook', 'Facebook', /FBAN|FBAV|FB_IAB|FBIOS|FB4A/],
    ['instagram', 'Instagram', /Instagram/],
    ['tiktok', 'TikTok', /musical_ly|BytedanceWebview|TikTok|trill_/i],
    ['snapchat', 'Snapchat', /Snapchat/],
    ['pinterest', 'Pinterest', /Pinterest/],
    ['linkedin', 'LinkedIn', /LinkedInApp/],
    ['telegram', 'Telegram', /Telegram/]
  ];
  var PAID_MEDIUM = /^(cpc|ppc|paid|paid_social|paidsocial|social_paid|ads?|display|cpm|retargeting|sponsored)$/i;

  function pick(list, value, idx) {
    for (var i = 0; i < list.length; i++) if (has(list[i][idx], value)) return list[i];
    return null;
  }

  function classify(p, ref, ua) {
    var src = (p.utm_source || '').toLowerCase();
    var med = (p.utm_medium || '').toLowerCase();
    var refHost = hostOf(ref);
    if (refHost === OWN || (refHost && OWN && refHost.slice(-OWN.length) === OWN)) refHost = '';
    var paid = PAID_MEDIUM.test(med);
    var r;

    // 1. Ad click ids — the most reliable signal
    if (p.gclid || p.gbraid || p.wbraid || p.gad_source) return out('google_ads', 'Publicité Google', 'paid_search', true);
    if (p.msclkid) return out('bing_ads', 'Publicité Bing', 'paid_search', true);
    if (p.ttclid) return out('tiktok_ads', 'Publicité TikTok', 'paid_social', true);
    if (p.twclid) return out('x_ads', 'Publicité X', 'paid_social', true);
    if (p.scclid || p.sccid) return out('snapchat_ads', 'Publicité Snapchat', 'paid_social', true);
    if (p.epik) return out('pinterest_ads', 'Publicité Pinterest', 'paid_social', true);

    // 2. Meta: Instagram / Facebook, ad or not
    var isIg = /^(ig|instagram)$/.test(src) || /(^|[.])instagram[.]com$/.test(refHost) || /Instagram/.test(ua);
    var isFb = /^(fb|facebook|an|msg|messenger)$/.test(src) || /(^|[.])facebook[.]com$/.test(refHost) || /FBAN|FBAV|FB_IAB|FBIOS|FB4A/.test(ua) || !!p.fbclid;
    if (isIg || isFb) {
      var metaAd = paid || !!p.utm_campaign && /^[0-9]{6,}$/.test(p.utm_campaign) || !!p.ad_id || !!p.adset_id || !!p.campaign_id;
      if (isIg) return metaAd ? out('instagram_ads', 'Publicité Instagram', 'paid_social', true) : out('instagram', 'Instagram', 'social', p.fbclid && !src ? null : false);
      return metaAd ? out('facebook_ads', 'Publicité Facebook', 'paid_social', true) : out('facebook', 'Facebook', 'social', p.fbclid && !src ? null : false);
    }

    // 3. AI assistants — tagged link or referrer
    if ((r = pick(AI, src, 3)) || (r = pick(AI, refHost, 2))) return out(r[0], r[1], 'ai', false);

    // 4. Other explicit UTM sources
    if (/^(whatsapp|wa)$/.test(src)) return out('whatsapp', 'WhatsApp', 'messaging', paid);
    if (/^(email|e-mail|newsletter|mail)$/.test(src) || med === 'email') return out('email', 'E-mail', 'email', false);
    if (src === 'google' && paid) return out('google_ads', 'Publicité Google', 'paid_search', true);
    if (src) {
      if ((r = pick(SOCIAL, src + '.com', 2))) return out(paid ? r[0] + '_ads' : r[0], (paid ? 'Publicité ' : '') + r[1], paid ? 'paid_social' : 'social', paid);
      return out('utm:' + src, 'Lien suivi : ' + src, paid ? 'paid_other' : 'campaign', paid);
    }

    // 5. Referrer
    if ((r = pick(SEARCH, refHost, 2))) return out(r[0] + '_search', r[1], 'search', false);
    if ((r = pick(SOCIAL, refHost, 2))) return out(r[0], r[1], r[0] === 'whatsapp' || r[0] === 'telegram' ? 'messaging' : 'social', false);
    if (refHost) return out('referral', 'Site : ' + refHost, 'referral', false);

    // 6. In-app browsers with no referrer
    if ((r = pick(IN_APP, ua, 2))) return out(r[0], r[1] + ' (application)', 'social', null);

    return out('direct', 'Accès direct', 'direct', false);
  }

  function out(channel, label, group, paid) {
    return { channel: channel, label: label, group: group, paid: paid };
  }

  function touch() {
    var p = params();
    var ref = document.referrer || '';
    var ua = navigator.userAgent || '';
    var c = classify(p, ref, ua);
    var keep = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'gbraid', 'wbraid', 'ttclid', 'msclkid'].forEach(function (k) {
      if (p[k]) keep[k] = p[k];
    });
    return {
      channel: c.channel, label: c.label, group: c.group, paid: c.paid,
      referrer: ref.slice(0, 300),
      landing: (location.pathname + location.search).slice(0, 300),
      params: keep,
      at: new Date().toISOString()
    };
  }

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
  }
  function write(v) {
    try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {}
    try { document.cookie = KEY + '=' + encodeURIComponent(JSON.stringify({ f: v.first.channel, l: v.last.channel })) + ';path=/;max-age=' + MAX_AGE_DAYS * 86400 + ';SameSite=Lax'; } catch (e) {}
  }

  var t = touch();
  var saved = read();
  var expired = saved && saved.first && (Date.now() - Date.parse(saved.first.at)) > MAX_AGE_DAYS * 86400000;
  var external = t.channel !== 'direct' || !saved;
  var newSession = false;
  try { newSession = !sessionStorage.getItem(KEY + '_s'); sessionStorage.setItem(KEY + '_s', '1'); } catch (e) {}

  if (!saved || expired) {
    saved = { first: t, last: t, visits: 1 };
  } else {
    if (external && (t.channel !== 'direct')) saved.last = t;
    if (newSession) saved.visits = (saved.visits || 1) + 1;
  }
  write(saved);

  window.AtlasSource = {
    get: function () {
      var s = read() || saved;
      return {
        first: s.first, last: s.last, visits: s.visits,
        device: /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent) ? 'mobile' : 'desktop',
        inApp: (pick(IN_APP, navigator.userAgent, 2) || [null])[0]
      };
    },
    classify: classify
  };
})();
